// components/LanguageSwitcher.js
import dynamic from 'next/dynamic';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
    localStorage.setItem('language', selectedLanguage);
  };

  return (
    <select onChange={handleLanguageChange} value={i18n.language}>
      <option value="en">English</option>
      <option value="hi">Hindi</option>
    </select>
  );
};

// Dynamically import with SSR disabled
export default dynamic(() => Promise.resolve(LanguageSwitcher), { ssr: false });
